module.exports = __webpack_public_path__ + "img/total-gaming.defc860d.png";